import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthenticatedAxios } from '../useAuthenticatedAxios';
import { toast } from '../../../components/Toast';
import { adminUserKeys } from './adminUsers.key';
import { CreateAdminUserPayload } from './adminUsers.types';

export function useCreateAdminUser() {
  const getAxios = useAuthenticatedAxios();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateAdminUserPayload) => {
      const axios = await getAxios();
      const res = await axios.post('/api/v1/admin-users', data);
      return res.data;
    },
    onSuccess: () => {
      toast.success('Administratör skapad');
      queryClient.invalidateQueries({ queryKey: adminUserKeys.all });
    },
    onError: () => toast.error('Kunde inte skapa administratör'),
  });
}
